
  import {Component, Vue} from "vue-property-decorator";
  import FormBuilderField from "@/modules/FormBuilder/components/FormBuilderField.vue";
  import {IFormBuilder} from "@/modules/FormBuilder/interfaces/form-builder.interface";
  import {IBook} from "@/interfaces/book.interface";
  import {ICorp} from "@/modules/Corps/interfaces/corp.interface";
  import {corpRequest} from "@/modules/Corps/resources/corp.resource";
  import {IApp} from "@/interfaces/app.interface";
  import {copyToClipboard} from "@/plugins/clipboard";
  import {IAppState} from "@/interfaces/app-state.interface";

  @Component({
    components: {FormBuilderField}
  })
  export default class CorpForm extends Vue {
    $refs: any;
    isDataReady = true;
    corpInfo: ICorp.IEntity = null;
    formModel: ICorp.IEntity = null;
    payload = null;
    createMode = false;

    get storeState(): IAppState { return this.$store.state; }

    get formFields(): IFormBuilder.IField[][] {
      let leftSideFields: IFormBuilder.IField[] = [
        { prop: 'id', type: IFormBuilder.FieldType.Input, label: 'Код', disabled: true, hidden: this.createMode, },
        { prop: 'name', type: IFormBuilder.FieldType.Input, label: 'Наименование', required: true, },
        { prop: 'email', type: IFormBuilder.FieldType.Input, label: 'E-mail', },
        { prop: 'phone', type: IFormBuilder.FieldType.Phone, label: 'Телефон', placeholder: '+7 (' },
        { prop: 'parks', type: IFormBuilder.FieldType.Select, label: 'Парковки', options: this.storeState.book.books[IBook.BookName.parks], multiple: true, },
        { prop: 'corpLimitResident', type: IFormBuilder.FieldType.Input, label: 'Лимит машин резидентов в ЛК', inputType: 'number', },
        { prop: 'inArchive', type: IFormBuilder.FieldType.Switcher, placeholder: 'Архив', },
      ];
      let rightSideFields: IFormBuilder.IField[] = [
        { prop: 'refCode', type: IFormBuilder.FieldType.Input, label: 'Реферальный код', hidden: this.createMode, },
        { prop: 'comment', type: IFormBuilder.FieldType.Textarea, label: 'Комментарий', },
      ];
      return [leftSideFields, rightSideFields];
    }

    formRules = {
      name: [{ required: true, message: ' ', trigger: 'blur' }],
    };

    created() {
      this.payload = {...this.storeState.dialog.payload.allPages.corpPopup};
      this.createMode = this.payload.createMode;
    }

    async mounted() {
      await this.getCorpInfo();
    }

    async getCorpInfo() {
      if (this.createMode) {
        this.corpInfo = {...ICorp.DefaultFormEntity};
        this.formModel = {...this.corpInfo};
      }
      else {
        let corpInfo = await corpRequest.getCorpInfo({ corpId: this.payload.corpId });
        this.corpInfo = {...corpInfo};
        this.formModel = {
          ...this.corpInfo,
          parks: (this.corpInfo.parks as ICorp.ICorpPark[]).map(park => park.id),
        };
      }
      this.isDataReady = true;
    }

    async saveChanges() {
      this.$refs.corpForm.validate(async (valid) => {
        if (!valid) return false;

        let requestData = await corpRequest.updateCorpInfo(this.formModel, this.createMode);
        if (requestData.success) {
          await this.$store.dispatch('book/getBook', {bookNames: [IBook.TableName.Corps], needUpdate: true});
          if (this.createMode) {
            this.$store.commit('corps/addNewTableItem', {corp: requestData.response.data.result.corps[0]});
          }
          if (this.payload.updateTableItem) {
            this.$store.commit('corps/updateTableItem', {corp: requestData.response.data.result.corps[0]});
          }
          this.$emit('onClose');
        }
      });
    }

    async getNewRefCode() {
      let refCode = await corpRequest.changeRefCode({ corpId: this.payload.corpId });
      this.formModel.refCode = refCode;
      this.corpInfo.refCode = refCode;
    }

    copyRefCode() {
      this.copyString(this.formModel.refCode, 'Реферальный код успешно скопирован');
    }

    copyLink() {
      let url = `${window.location.origin}${IApp.RoutePath[IApp.ROUTE_NAME.PAGE_AUTHORIZATION]}?${ICorp.UrlGetParams.RefLink}=${this.formModel.refCode}`;
      this.copyString(url, 'Ссылка успешно скопирована');
    }

    copyString(copyValue: string, message: string) {
      copyToClipboard(copyValue);
      this.$notify({
        title: 'Успешно',
        message,
        type: 'success'
      });
    }
  }
